/**
 * CargoStatus
 * @author Thacryba
 */
import {Resource} from 'simpli-web-sdk'

/* TODO: review generated class */
export class CargoStatus extends Resource {
  idStatusDocument: number = 0
  description: string | null = null
  active: boolean | null = null

  get $id() {
    return this.idStatusDocument
  }
  set $id(val) {
    this.idStatusDocument = val
  }
  get $tag() {
    return String(this.description)
  }
}
